import { render, staticRenderFns } from "./LocalizationEdemaBlock.vue?vue&type=template&id=7cab180e&lang=pug&"
import script from "./LocalizationEdemaBlock.vue?vue&type=script&lang=js&"
export * from "./LocalizationEdemaBlock.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationEdemaBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports